import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_MENU, GET_BADGE_MENU } from "actions/Menu/actionTypes";
import {
  getMenuSuccess,
  getMenuFailure,
  getBadgeMenuSuccess,
  getBadgeMenuFailure,
} from "actions/Menu";
import MenuApi from "service/menuApi";
import { pushNotification } from "utils/notifications";

function* getMenu(action) {
  try {
    const response = yield call(MenuApi.getMenu1, {});
    if (response.ok) {
      yield put(getMenuSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getMenuFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getMenuFailure());
  }
}

function* getBadgeMenu(action) {
  try {
    const response = yield call(MenuApi.getBadgeMenu, {});
    if (response.ok) {
      yield put(getBadgeMenuSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getBadgeMenuFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getBadgeMenuFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_MENU, getMenu);
  yield takeLatest(GET_BADGE_MENU, getBadgeMenu);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
